import { isGlobalworth } from 'config'
import { useRemoteConfigContext } from 'shared/components'

export const useSupportContact = () => {
  const remoteConfig = useRemoteConfigContext()
  const flavor = isGlobalworth ? 'globalworth' : 'bluebolt'

  return {
    phone: remoteConfig?.[`${flavor}_help_phone_number`],
    email: remoteConfig?.[`${flavor}_help_email`],
  }
}
